/**
 * The anti-bot widget (Cloudflare Turnstile), shared by the two public pages
 * that ask for it: a survey link and the onboarding page.
 */

export interface TurnstileApi {
  render: (
    container: HTMLElement,
    options: {
      sitekey: string
      callback: (token: string) => void
      'expired-callback'?: () => void
      'error-callback'?: () => void
    },
  ) => string
  reset: (widgetId?: string) => void
}

declare global {
  interface Window {
    turnstile?: TurnstileApi
  }
}

const TURNSTILE_SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

/** Loads the anti-bot script once, however many times the page mounts. */
export function loadTurnstile(): Promise<TurnstileApi> {
  return new Promise((resolve, reject) => {
    if (window.turnstile) return resolve(window.turnstile)

    const existing = document.querySelector<HTMLScriptElement>(`script[src="${TURNSTILE_SCRIPT}"]`)
    const script = existing ?? document.createElement('script')

    script.addEventListener('load', () =>
      window.turnstile ? resolve(window.turnstile) : reject(new Error('turnstile missing')),
    )
    script.addEventListener('error', () => reject(new Error('turnstile failed to load')))

    if (!existing) {
      script.src = TURNSTILE_SCRIPT
      script.async = true
      document.head.appendChild(script)
    }
  })
}
